// extracted by mini-css-extract-plugin
export default {"main":"buttonord_main__x27ud","title":"buttonord_title__T+99l","icon":"buttonord_icon__L2ni0","circle":"buttonord_circle__0xDGM"};